import * as React from "react";
import { connect } from "react-redux";
import { IdResource } from "../../../constants/IdResource";
import { IdStyles } from "../../../less/IdStyles";
import { selectEventBuffByTargetId } from "../../../selectors/selectBuffsInfo";
import { selectActiveDiscountEventInfoByEventType } from "../../../selectors/selectEventInfo";
import { selectOutskirtBuildingUpgradeRequirementsResourceInfo } from "../../../selectors/selectOutskirtBuildingUpgradeInfo";
import { utilBuff } from "../../../utils/utilBuff";
import { EventType } from "../../balancing/types/BalancingCore";
import { IdInventoryResourceRequirementPosition } from "../../generic/inventory-resource-requirement/IdInventoryResourceRequirementPosition";
import { InventoryResourceRequirement } from "../../generic/inventory-resource-requirement/InventoryResourceRequirement";
import { List } from "../../generic/list/List";
import { NumberFormat } from "../../generic/number-format/NumberFormat";
import { TypeNumberRounding } from "../../generic/round-format/TypeNumberRounding";
var _OutskirtBuildingUpgradeRequirements = function (_a) {
    var goldDiscountBuff = _a.goldDiscountBuff, requirements = _a.requirements;
    var renderRequirement = function (requirement) {
        var amount = requirement.amount, id = requirement.id;
        var discountedRequirement = id === IdResource.Gold && goldDiscountBuff
            ? utilBuff.applyTo(amount, goldDiscountBuff, TypeNumberRounding.Ceil)
            : undefined;
        var oldRequirement = discountedRequirement != undefined && (React.createElement("span", { className: "previous-price" },
            React.createElement(NumberFormat, { amount: amount, className: IdStyles.TextBoldSecondaryOutline })));
        return (React.createElement(InventoryResourceRequirement, { key: id, resourceId: id, required: discountedRequirement || amount, iconStyleId: IdStyles.IconMedium, position: IdInventoryResourceRequirementPosition.Horizontal }, oldRequirement));
    };
    if (!requirements || requirements.length === 0) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(List, { items: requirements, renderItem: renderRequirement, className: IdStyles.BuildingUpgradeRequirementWrapper + " flex flex--centered" }));
};
var mapState = function (state, ownProps) {
    var event = selectActiveDiscountEventInfoByEventType(state, EventType.OutskirtDiscount);
    var goldDiscountBuff = event != undefined ? selectEventBuffByTargetId(state, event, IdResource.Gold) : undefined;
    return {
        goldDiscountBuff: goldDiscountBuff,
        requirements: selectOutskirtBuildingUpgradeRequirementsResourceInfo(state, ownProps.buildingId),
    };
};
export var OutskirtBuildingUpgradeRequirements = connect(mapState)(_OutskirtBuildingUpgradeRequirements);



//////////////////
// WEBPACK FOOTER
// ./src/features/outskirts/upgrade/OutskirtBuildingUpgradeRequirements.tsx
// module id = 2640
// module chunks = 3